module.exports = __webpack_public_path__ + "static/media/durant_jersey.e2e56b1a.jpg";